/* Exact exported native Sign Maker icon keychains. Millimetres, Y up.
 * Customer input selects registered geometry; it cannot change dimensions or paths. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PCKeychainIconGeometry = factory();
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  const identity = ['keychain-icon-v1', 1, '2026-09-06.1'];
  const fields = ['schemaVersion','templateId','revision','iconId','baseColorId','loopSide'];
  function validate(data, c) {
    if (!data || data.templateId !== identity[0] || data.schemaVersion !== identity[1] || data.revision !== identity[2] || !Array.isArray(data.icons) || !Array.isArray(data.colors)) throw new Error('The icon keychain collection could not load. Please refresh.');
    if (!c || typeof c !== 'object' || Array.isArray(c) || Object.keys(c).length !== fields.length || Object.keys(c).some(k => !fields.includes(k))) throw new Error('This saved icon keychain has unsupported settings.');
    if (c.templateId !== identity[0] || c.schemaVersion !== identity[1] || c.revision !== identity[2]) throw new Error('This icon keychain revision is not supported.');
    const icon = data.icons.find(i => i.id === c.iconId);
    if (!icon) throw new Error('Choose an available keychain icon.');
    if (!data.colors.some(x => x.id === c.baseColorId) || !['left','right'].includes(c.loopSide)) throw new Error('Choose a base color and attachment side.');
    if (new Set([c.baseColorId].concat(icon.colorIds)).size > data.production.maxColorSlots) throw new Error('Use up to eight filament colors.');
    if (!icon.shapes || !icon.shapes[c.loopSide]) throw new Error('This attachment option could not load.');
    return c;
  }
  function bounds(paths) {
    const b = [Infinity, Infinity, -Infinity, -Infinity];
    paths.forEach(r => r.forEach(p => {b[0]=Math.min(b[0],p[0]);b[1]=Math.min(b[1],p[1]);b[2]=Math.max(b[2],p[0]);b[3]=Math.max(b[3],p[1]);}));
    return b;
  }
  function path(paths) { return paths.map(r => 'M' + r.map(p => p[0]+','+(-p[1])).join('L') + 'Z').join(' '); }
  function solve(data, c) {
    validate(data, c);
    const icon = data.icons.find(i => i.id === c.iconId);
    const shape = JSON.parse(JSON.stringify(icon.shapes[c.loopSide]));
    shape.baseColor = data.colors.find(x => x.id === c.baseColorId).hex;
    shape.spec = Object.assign({}, data.production);
    shape.displayName = icon.label;
    return shape;
  }
  return {validate, solve, path, bounds};
}));
